import { Component, inject, effect } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { BrandingService } from '@next/core-lib/branding';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

import { listAnimations } from '../../../../animations';
import { Customer, SiteState } from '../../../../shared/models/shared.model';
import { getCustomerRelationsRequest } from '../../../store/contactperson.actions';
import {
  getCustomersWithRelations,
  getSelectedContactpersonId,
} from '../../../store/contactperson.selectors';

@Component({
  selector: 'app-contactperson-relations',
  templateUrl: './relations-overview.component.html',
  styleUrls: ['./relations-overview.component.scss'],
  animations: [listAnimations],
  standalone: false,
})
export class RelationsOverviewComponent {
  private readonly store = inject<Store<SiteState>>(Store);
  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly brandingService = inject(BrandingService);

  contactpersonId$: Observable<number> = this.store.select(getSelectedContactpersonId);
  readonly contactpersonIdSignal = toSignal(this.contactpersonId$.pipe(filter((id) => !!id)), {
    initialValue: null as number | null,
  });
  customersWithRelations$: Observable<Customer[]> = this.store.select(getCustomersWithRelations);

  isAgrifirm: boolean = this.brandingService.isTenant('Agrifirm');

  constructor() {
    effect(() => {
      const contactpersonId = this.contactpersonIdSignal();
      if (contactpersonId) {
        this.store.dispatch(getCustomerRelationsRequest({ id: contactpersonId }));
      }
    });
  }

  addRelation() {
    this.router.navigate(['add'], { relativeTo: this.activatedRoute });
  }
}
